import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import Turnstile from '../components/Turnstile'

export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState('')
  const [loading, setLoading] = useState(false)
  const [sent, setSent]       = useState(false)
  const [error, setError]     = useState('')
  const [captchaToken, setCaptchaToken] = useState(null)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email.trim()) return setError('Please enter your email address.')
    if (import.meta.env.VITE_TURNSTILE_SITE_KEY && !captchaToken) {
      return setError('Please complete the verification.')
    }
    setLoading(true)
    setError('')
    const { error: err } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/reset-password`,
      captchaToken,
    })
    setLoading(false)
    if (err) {
      setError(err.message)
    } else {
      setSent(true)
    }
    setCaptchaToken(null)
  }

  return (
    <div className="auth-page">
      <div className="auth-panel">
        <div className="auth-panel__blobs">
          <div className="auth-panel__blob auth-panel__blob--1" />
          <div className="auth-panel__blob auth-panel__blob--2" />
          <div className="auth-panel__blob auth-panel__blob--3" />
        </div>
        <div className="auth-panel__content">
          <Link to="/" className="auth-panel__logo">
            <div className="auth-panel__logo-icon">V</div>
            Verse
          </Link>
          <blockquote className="auth-panel__quote">
            "Every great story starts with a single word. Yours is waiting."
          </blockquote>
        </div>
      </div>

      <div className="auth-form-panel">
        <div className="auth-form-wrap">
          {sent ? (
            <>
              <div className="auth-form-header">
                <h1 className="auth-form-title">Check your email</h1>
                <p className="auth-form-subtitle">
                  We sent a password reset link to <strong>{email}</strong>.
                  It may take a minute to arrive.
                </p>
              </div>
              <p style={{ fontSize: '0.88rem', color: 'var(--text-faint)', marginTop: 24 }}>
                Didn't get it? Check your spam folder or{' '}
                <button
                  style={{ background: 'none', border: 'none', color: 'var(--purple)', cursor: 'pointer', fontSize: 'inherit', padding: 0, fontWeight: 600 }}
                  onClick={() => setSent(false)}
                >
                  try again
                </button>.
              </p>
              <Link to="/login" className="btn btn-primary auth-submit" style={{ marginTop: 24, display: 'block', textAlign: 'center' }}>
                Back to sign in
              </Link>
            </>
          ) : (
            <>
              <div className="auth-form-header">
                <h1 className="auth-form-title">Forgot password?</h1>
                <p className="auth-form-subtitle">Enter your email and we'll send you a reset link.</p>
              </div>

              <form className="auth-form" onSubmit={handleSubmit} noValidate>
                {error && <div className="auth-error">{error}</div>}
                <div className="auth-field">
                  <label className="auth-label" htmlFor="email">Email</label>
                  <input
                    id="email"
                    type="email"
                    className="auth-input"
                    placeholder="you@example.com"
                    value={email}
                    onChange={e => { setEmail(e.target.value); setError('') }}
                    autoComplete="email"
                    autoFocus
                  />
                </div>
                <Turnstile onToken={setCaptchaToken} onExpire={() => setCaptchaToken(null)} />

                <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
              </form>

              <p className="auth-switch">
                Remember it?{' '}
                <Link to="/login" className="auth-switch-link">Back to sign in</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
